module.exports = __webpack_public_path__ + "assets/tree.5bfe6c7f.svg";